export const CUSTOMER_SERVICE_BASE_URL = 'services/customerservice';

export const APPOINTMENT_ENDPOINT = `${CUSTOMER_SERVICE_BASE_URL}/api/tls/appointment`;

export const APPOINTMENT_AMEND = `${CUSTOMER_SERVICE_BASE_URL}/api/tls/appointment/group_appointment/book`;
